import React, { memo } from "react";

import styles from "./styles.module.scss";
import CommentInput from "../commentInput";
import CommentsList from "../commentsList";
import { IMarketplaceOfferRawData } from "models";

interface ICommentsSection {
	marketplacePost: IMarketplaceOfferRawData;
}

const CommentsSection: React.FunctionComponent<ICommentsSection> = ({
	marketplacePost,
}) => {
	return (
		<div className={styles.container}>
			<CommentInput />
			<CommentsList />
		</div>
	);
};

export default memo(CommentsSection);
